import { render, staticRenderFns } from "./sajoDetail.vue?vue&type=template&id=43104b8b&scoped=true"
import script from "./sajoDetail.vue?vue&type=script&lang=js"
export * from "./sajoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43104b8b",
  null
  
)

export default component.exports